import { useState } from 'react';

interface ImportAnalysis {
  totalLines: number;
  errorLines: number;
  importableLines: number;
  errorPercentage: number;
}

interface ImportError {
  message: string;
  line?: number;
  field?: string;
  value?: string;
  error?: string;
}

interface ImportState {
  isError: boolean;
  isPreview: boolean;
  errors: ImportError[];
  originalFile: File | null;
  analysis: ImportAnalysis | null;
  importType: 'performances' | 'points' | 'companies' | 'users' | 'references' | 'targets';
}

export function useImportState(
  importType: 'performances' | 'points' | 'companies' | 'users' | 'references' | 'targets'
) {
  const [state, setState] = useState<ImportState>({
    isError: false,
    isPreview: false,
    errors: [],
    originalFile: null,
    analysis: null,
    importType
  });

  const setErrorState = (
    errors: ImportError[],
    file: File,
    analysis: ImportAnalysis | null = null
  ) => {
    setState({
      isError: errors.length > 0,
      isPreview: true,
      errors,
      originalFile: file,
      analysis,
      importType
    });
  };

  const setPreviewState = (
    errors: ImportError[],
    file: File,
    analysis: ImportAnalysis | null = null
  ) => {
    setErrorState(errors, file, analysis);
  };

  const resetState = () => {
    setState({
      isError: false,
      isPreview: false,
      errors: [],
      originalFile: null,
      analysis: null,
      importType
    });
  };

  const retryImport = () => {
    setState((prev) => ({
      ...prev,
      isError: false,
      isPreview: false,
      errors: [],
      analysis: null
    }));
  };

  return {
    state,
    setErrorState,
    setPreviewState,
    resetState,
    retryImport
  };
}
